import React from "react";
import Slider from "react-slick";
import he from "he";
import PropTypes from "prop-types";

import CarouselCard from "./CarouselCard";
import NextArrow from "./NextArrow";
import PrevArrow from "./PrevArrow";

class PostCarousel extends React.Component {
  constructor(props) {
    super(props);
  }

  /**
   * Render Items
   * creates the react child components for the <Slider/>
   * @param {array} items - to map to returned components
   * @returns {array} cards - react components
   */
  renderItems(items = []) {
    const cards = items.map(item => {
      const pageLink = item.link;
      const externalLink = item.external_link;
      const hasExternal = item.post_type == "external_link" ? true : false;

      return (
        <CarouselCard
          key={item.id}
          title={he.decode(item.title)}
          link={hasExternal ? externalLink : pageLink}
          images={item.images}
        ></CarouselCard>
      );
    });
    return cards;
  }

  render() {
    var settings = {
      // centerMode: true,
      centerPadding: "50px",
      dots: false,
      infinite: this.props.items.length >= 3 ? true : false,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 3,
      prevArrow: <PrevArrow />,
      nextArrow: <NextArrow />,
      responsive: [
        {
          breakpoint: 2400,
          settings: {
            infinite: this.props.items.length >= 5 ? true : false,
            slidesToShow: 4,
            slidesToScroll: 4
          }
        },
        {
          breakpoint: 1800,
          settings: {
            infinite: this.props.items.length >= 4 ? true : false,
            slidesToShow: 3,
            slidesToScroll: 3
          }
        },
        {
          breakpoint: 900,
          settings: {
            infinite: this.props.items.length >= 3 ? true : false,
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 600,
          settings: {
            infinite: this.props.items.length >= 2 ? true : false,
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    };
    return <Slider {...settings}>{this.renderItems(this.props.items)}</Slider>;
  }
}

PostCarousel.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      link: PropTypes.string.isRequired
    })
  )
};

export default PostCarousel;
